import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ModalColorSelectorComponent } from './modal-color-selector/modal-color-selector.component';
import { ModalIconSelectorComponent } from './modal-icon-selector/modal-icon-selector.component';
/* import { ModalShareFileComponent } from './modal-share-file/modal-share-file.component'; */
import { ModalDeleteComponent } from './modal-delete/modal-delete.component';
import { ModalWarningComponent } from './modal-warning/modal-warning.component';
import { ModalPreviewImageComponent } from './modal-preview-image/modal-preview-image.component';
import { CommonComponentsModule } from '../common-components/common-components.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ModalShareFileComponent } from './modal-share-file/modal-share-file.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}


@NgModule({
  declarations: [
    ModalColorSelectorComponent,
    ModalIconSelectorComponent,
     ModalShareFileComponent,
    ModalDeleteComponent,
    ModalWarningComponent,
    ModalPreviewImageComponent
  ],
  imports: [
    CommonModule,
    CommonComponentsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [
    ModalColorSelectorComponent,
     ModalShareFileComponent,
    ModalDeleteComponent,
    ModalIconSelectorComponent,
    ModalWarningComponent,
    ModalPreviewImageComponent
  ]
})
export class ModalsModule { }
